import React from 'react';
import {RoutePermittedRole} from 'shared/constants/AppConst';
import EmailSettings from './emailSettings/EmailSettingsLG';

export const settingsPagesConfigs = [
  {
    permittedRole: RoutePermittedRole.admin,
    path: '/settings/email-configuration',
    element: <EmailSettings />,
  },
];
